import { VueController } from 'util/vue_controller'

// Connects to data-controller="pricing-statewide-rollup"
export default class extends VueController {
  static vueComponent = 'pricing-statewide-rollup'

  static targets = ['tableBody']

  static values = {
    pricingPrograms: Array,
    chains: Array,
    contributions: Array
  }

  get props () {
    return {
      chains: this.chainsValue,
      pricingPrograms: this.pricingProgramsValue,
      contributions: this.contributionsValue
    }
  }

  get vueTarget () {
    return this.tableBodyTarget
  }
}
